// Meta Pixel (Facebook Pixel) utility
// Pixel ID: 916313891230397

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '916313891230397')

  initialized = true
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(
  price: number,
  currency: string = 'ARS',
  contentName: string = 'Botiquín Ancestral',
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      value: price,
      currency: currency,
      content_name: contentName,
      content_type: 'product',
    })
  }
}

export function trackViewContent(
  contentName: string = 'Botiquín Ancestral - Landing Page',
  value: number = 17990,
  currency: string = 'ARS',
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: contentName,
      content_type: 'product',
      value: value,
      currency: currency,
    })
  }
}

export function trackLead(
  contentName: string = 'CTA Click - Botiquín Ancestral',
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: contentName,
    })
  }
}

export function trackClick(buttonName: string): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'CTAClick', {
      button_name: buttonName,
    })
  }
}

export function trackInitiateCheckout(
  value: number = 17990,
  currency: string = 'ARS',
  contentName: string = 'Botiquín Ancestral',
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: value,
      currency: currency,
      content_name: contentName,
      content_type: 'product',
    })
  }
}
